import * as types from './mutation-types'

export default {
  [types.SET_BANNERS] (state, payload) {
    state.banners = payload.data || []
  }
}
